// todo: draw figures from renderer
import {Square} from '../figures/square';
import {Circle} from '../figures/circle';
import {Triangle} from '../figures/triangle';
import {Star} from '../figures/star';
import {Heart} from '../figures/heart';
import {Shape} from '../figures/shape';
import {Unknownpsy} from '../figures/unknownpsy';

export class BasicModelerRenderer {

  // todo: later this is model
  public objects = [];
  public connections = [];
  //
  private schemeId;
  private schemesList;
  private schemeName;

  // property for background color of all area
  private canvasBackgroundColor = 'black';

  constructor(private ctx: CanvasRenderingContext2D, private width, private height) {
  }

  public savedSchemA;


  createShape(type, name, x:number, y:number, z:number, id:string) {
      let obj: Shape;
      if ('DF.AHM1' === type) {
          obj = new Square(this.ctx, name, x, y, z, id);
      }
      if ('KF.AHM1' === type) {
          obj = new Circle(this.ctx, name, x, y, z, id);
      }
      if ('AF.AHM1' === type) {
          obj = new Triangle(this.ctx, name, x, y, z, id);
      }
      if ('THP.AHM1' === type) {
          obj = new Star(this.ctx, name, x, y, z, id);
      }
      if ('MHP.AHM1' === type) {
          obj = new Heart(this.ctx, name, x, y, z, id);
      }
      if ('UNKNOWN.AHM1' === type) {
        obj = new Unknownpsy(this.ctx, name, x, y, z, id);
      }

      this.objects.push(obj);
      // return obj;
  }

  saveThisScheme(name, type) {
    // console.log('saveThisScheme', name, type);

    const scheme = [];
    scheme.push(name);
    scheme.push(type);
    const objects = Object.assign([], this.objects);
    // console.log(' this.objects',  this.objects);
    scheme.push(objects);
    const connections = Object.assign([], this.connections);
    // console.log('this.connections', this.connections);
    scheme.push(connections);

    // save to db
    let allObjects = '';
    for (let i in this.objects) {
      const obj = this.objects[i];
      allObjects += obj.serialization();
    }
    let allConnections = '';
    for (let j in this.connections) {
      const conn = this.connections[j];
      allConnections += conn.serialization();
    }

    // console.log('serialization -> ', allConnections);

    this.savedSchemA = allObjects + allConnections;

    this.objects = [];
    this.connections = [];
    this.redrawAllObjects(null);

    return scheme;
  }

  /**
   * returns psy found by id
   *
   * @param shapeId
   */
  findShapeById(shapeId: string) {
    for (let i in this.objects) {
      let object = this.objects[i];
      if (shapeId == object.id) {
        return object;
      }
    }
  }

  uploadThisScheme(scheme) {
    // console.log('upload', scheme);
    this.objects = scheme[2];
    this.connections = scheme[3];
    this.redrawAllObjects(null);
  }

  // todo: select and create connection
  putNewFigure(obj) {
    if (null != obj) {
      let psychotypeExist: boolean = false;
      for (const i in this.objects) {
        const shape = this.objects[i];
        if (obj.id === shape.id) {
          psychotypeExist = true;
        }
      }
      if (!psychotypeExist) {
        this.objects.push(obj);
      }
    }
  }

  putNewConnection(connection) {
    if (null != connection) {
      let psychotypeExist: boolean = false;
      for (const i in this.connections) {
        const conn = this.connections[i];
        if (connection.id === conn.id) {
          psychotypeExist = true;
        }
      }
      if (!psychotypeExist) {
        this.connections.push(connection);
      }
    }
  }

  /**
   *
   * @param psychotype - selected psychotype, if null - no selected
   */
  redrawAllObjects(psychotype) {

    // console.log('redrawAllObjects 1 ->', this.objects, psychotype);

    this.ctx.fillStyle = this.canvasBackgroundColor;
    this.ctx.fillRect(0, 0, this.width, this.height);

    // draw all connections
    for (const i in this.connections) {
      const connection = this.connections[i];
      if (null != connection) {
        connection.draw();
        // // console.log('redrawAllConnections->', this.connections[i], this.connections);
      }
    }

    // draw all shapes
    for (const i in this.objects) {
      const shape = this.objects[i];
      if (null != shape) {
          // todo: some figures after uploading were not drawing
        // if (
        //   ( /*avoid double drawing figures with different coords*/
        //     null != psychotype &&
        //     psychotype.id !== shape.id
        //   ) ||
        //   null == psychotype
        // ) {
          shape.drawOnDefPosition();
          // console.log('redrawAllObjects 2 ->', this.objects[i]);
        // }
      }
    }

  }

  getPsychotypeByCoords(x, y) {
    // console.log('r->getPsychotypeByCoords');
    for (let i in this.objects) {
      const shape = this.objects[i];
      if (null != shape) {
        if (x > shape.x && x < shape.x + 100) {
          if (y > shape.y && y < shape.y + 100) {
            return shape;
          }
        }
      }
    }
  }

}
